import PageContainerFull from "../components/layout/PageContainerFull";
import PageSection from "../components/layout/PageSection";
import PageTitle from "../components/layout/PageTitle";
import Card from "../components/forms/Card";
import axios from "axios";
import {Apis} from "../util/data";
import {useEffect, useState} from "react";
import image from "../img/bannerpromsalud.png"
import logo from "../img/logo.png"
import useWindowDimensions from "../hooks/useWindowDimensions";
import {useForm} from "react-hook-form";
import FormGroup from "../components/forms/FormGroup";
import Input from "../components/forms/FormEl";
import Button from "../components/forms/Button";
import {errorToast, successToast} from "../components/layout/ToastStyles";
import useModal from "../modals/useModal";
import ExcelReader from "../components/ExcelReader";
import GenericModal2 from "../modals/GenericModal2";

const Reset = () => {

  const [token,setToken] = useState('')

  const {
    register,
    handleSubmit,
    watch,
    formState:{errors}
  } = useForm();

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const resetToken = urlParams.get('resetToken');
    if (resetToken) {
      setToken(resetToken);
    } else {
      errorToast("Error al obtener el token")
    }
  }, []);

  const { height } = useWindowDimensions();

  const resetAccount =async (contrasena) =>{
    try {
      const body = {contrasena: contrasena,token: token}
      const {data} = await axios.post(Apis.PROD + "/api/v1/auth/reset",body)
      if (data) {
        if(data.includes("exito")) successToast(data)
        else errorToast(data)
      }
    }
    catch (error){
      errorToast("Token incorrecto o ya utilizado. Por favor, solicite de nuevo otro correo")
      console.log(error)
    }
  }

  const contrasena = watch("contrasena")

  const onSubmit = async (params) => {
    await resetAccount(params.contrasena)
  }

  return(
    <PageContainerFull style={{padding: 0}}>
      <div style={{display: "flex", flexDirection: "row", alignItems: 'center',height: '100%'}}>
        <div style={{padding: 10, height: height, display: "flex", flexDirection: 'column', justifyContent: 'space-around', alignItems: 'center'}}>
          <img style={{height: 120,width: 120}} src={logo} alt={'logo'}/>
          <Card padding style={{width: '350px'}}>
            <PageSection>
              <PageTitle title={"Cambiar contraseña"}/>
            </PageSection>
            <PageSection>
              <FormGroup>
                <label>Nueva contraseña</label>
                <Input type='password' {...register("contrasena", {
                  required: "La contraseña es requerida",
                  minLength: {
                    value: 8,
                    message:"La contraseña debe tener al menos 8 caracteres"
                }
                })}/>
                {errors.contrasena && <div style={{color:'red'}}>{errors.contrasena.message}</div>}
              </FormGroup>
              <FormGroup>
                <label>Confirmar nueva contraseña</label>
                <Input type='password' {...register("confirm",{
                  required: "Por favor confirme su contraseña",
                  validate: value => value === contrasena || "Las contraseñas no coinciden"
                })}/>
                {errors.confirm && <div style={{color:'red'}}>{errors.confirm.message}</div>}
              </FormGroup>
            </PageSection>
            <PageSection>
              <Button onClick={handleSubmit(onSubmit)} variant={'primary'}>
                Continuar
              </Button>
            </PageSection>
          </Card>
        </div>
        <img style={{overflow: 'hidden', height: height}} src={image} alt={'imagen'}/>
      </div>
    </PageContainerFull>
  )
}

export default Reset
